(() => {
  const userRegistration = '.inquiry-user-registration-js';
  const passwordForm = '.inquiry_password_form';
  const password = '.inquiry-registration-password';
  const passwordConfirmation = '.inquiry-registration-password-confirmation';

  const init = () => {
    if (location.href.indexOf('customer/inquiry/new') < 1 ) return;
    if (!$(userRegistration).prop('checked')) {
      $(passwordForm).hide();
    }
    $('body').on('click', userRegistration, toggleNewPasswordForm);
  }

  const toggleNewPasswordForm = () => {
    if ($(userRegistration).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(passwordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(passwordForm).fadeOut();
    }
  }

  $(init);
})();


